module.exports = __webpack_public_path__ + "img/brand_linkedin.78484f3d.svg";